import React, { useState } from "react";
import MetaTags from "@components/shared/metaTags";
import { GetStaticPropsContext } from "next";
import { useQuery } from "@tanstack/react-query";
import { GQLDomains } from "@gql/types/gql";
import initialCall from "@helpers/initial-call";
import LoaderGlobal from "@components/shared/loaderGlobal";
import { getKeyWordsForMetaTags } from "@lib/sharedUtils";
import SiteMap from "@components/siteMap";
import { translate } from "@helpers/translationObjectFormatter";
import { ICustomDomain, TranslationsObject } from "@genericTypes/sharedTypes";
import Breadcrumb from "@components/shared/breadcrumb";

const SiteMapPage = () => {
    const [loading, setLoading] = useState(false);
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);

    const breadcrumbArr = [
        {
            label: translate(translations, "several_general_breadcrumb_home"),
            link: "/",
            isActive: true,
            showOnMobile: true,
        },
        {
            label: translate(translations, "several_siteMapPage_SiteMap"),
            link: "",
            isActive: false,
            showOnMobile: true,
        },
    ];
    const { data: domainInfo } = useQuery<ICustomDomain, Error>({
        queryKey: ["domain"],
    });

    return (
        <>
            {loading && <LoaderGlobal />}
            <MetaTags
                title={`${translate(
                    translations,
                    "several_siteMapPage_SiteMap",
                )} | Several.com`}
                description={translate(
                    translations,
                    "several_siteMapPage_meta_description",
                )}
                keyWords={
                    getKeyWordsForMetaTags(
                        domainInfo?.domain as GQLDomains,
                    ) as string
                }
            />

            <section className="max-w-7xl mx-auto px-5">
                <Breadcrumb arr={breadcrumbArr} />
                <h1 className="hidden">Site Map</h1>
                <SiteMap onSetLoading={setLoading} />
            </section>
        </>
    );
};
export const getStaticProps = async (ctx: GetStaticPropsContext) => {
    return await initialCall("SiteMap", ctx);
};
export default SiteMapPage;
